import React from "react";
import { Accordion, Button, Card } from "react-bootstrap";
import { translate } from "../Language/Translate";
import { BlackWhite } from "../styledComponents/colors";
import TextbausteinMain from "../Textbausteine/TextbausteinMain";

const CardTextbausteinArea = ({ eventKey }) => {

  return (
    <Card style={{ backgroundColor: "#e5e9df", color: "#1a1620" }}>
      <Card.Header>
        <Accordion.Toggle as={Button} variant="link" eventKey={eventKey}>
          <h6>
            <BlackWhite>{translate("Textbausteine")}</BlackWhite>
          </h6>
        </Accordion.Toggle>
      </Card.Header>
      <Accordion.Collapse eventKey={eventKey} id={eventKey}>
        <Card.Body>
          <TextbausteinMain />
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};
export default CardTextbausteinArea;
